import type { SVGProps } from "react";
const SvgHealtcare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M8.396 2.552c1.474-.914 2.762-.546 3.535.041.317.24.476.36.569.36s.252-.12.569-.36c.773-.587 2.06-.955 3.535-.041 1.936 1.2 2.374 5.156-2.09 8.494-.851.636-1.276.954-2.014.954s-1.163-.318-2.013-.954C6.022 7.708 6.46 3.751 8.396 2.552Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4 14h2.395c.294 0 .584.066.847.194l2.042.988c.263.127.553.193.848.193h1.042c1.008 0 1.826.791 1.826 1.767 0 .04-.027.074-.066.085l-2.541.703a1.95 1.95 0 0 1-1.368-.124L6.842 16.75"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m13 16.5 4.593-1.411a1.985 1.985 0 0 1 2.204.753c.369.51.219 1.242-.319 1.552l-7.515 4.337a2 2 0 0 1-1.568.187L4 20.02"
    />
  </svg>
);
export default SvgHealtcare;
